import "./SelectWorkflowTemplateModal.css";

import { ActionButtons, Autocomplete, Column, Modal, Row } from "../../../../widget";
import { ApplyWorkflowTemplatePanel } from "../../workflows/workflow-templates/workflow-template/components";
import { useSelectWorkflowTemplateModal } from "./useSelectWorkflowTemplateModal";

interface SelectWorkflowTemplateModalProps {
  show: boolean;
  closeModal: () => void;
  dealUuid?: string;
  projectUuid?: string;
  projectTypeUuid?: string;
  workflowType?: "Deal" | "Project";
}

export const SelectWorkflowTemplateModal = ({
  show,
  closeModal,
  dealUuid,
  projectUuid,
  projectTypeUuid,
  workflowType = "Project",
}: SelectWorkflowTemplateModalProps): JSX.Element => {
  const {
    templateList,
    selectedTemplate,
    selectedTemplateUuid,
    showApplyWorkflowTemplatePanel,
    handleSelectTemplate,
    handleTemplateSearch,
    handleSubmit,
    onCancel,
  } = useSelectWorkflowTemplateModal({
    closeModal,
    projectTypeUuid,
    workflowType,
    show,
  });

  return (
    <>
      <Modal show={show} title="Apply new workflow template" onClose={onCancel}>
        <form onSubmit={(e) => handleSubmit(e)}>
          <Row spacingV="xl">
            <Column offset={1} span={10} justify="center">
              <p className="body1">
                When applying the selected workflow to a new {workflowType.toLowerCase()}, the template set of phases,
                steps, and related tasks will be assigned to the {workflowType.toLowerCase()} based on its current
                status.
              </p>
            </Column>
          </Row>
          <Row spacingV="ll">
            <Column offset={3} span={6}>
              <div className="SelectWorkflowTemplateModalPhaseSelectorWrapper">
                <Autocomplete
                  label="Search workflows"
                  placeholder="Search for workflow"
                  data={templateList}
                  onSelect={handleSelectTemplate}
                  onTypeSearch={handleTemplateSearch}
                  initialKey={selectedTemplateUuid}
                />
              </div>
            </Column>
          </Row>
          <Row justify="center">
            <ActionButtons disabled={!selectedTemplateUuid} onCancel={onCancel} submitButtonLabel="Apply" />
          </Row>
        </form>
      </Modal>
      <ApplyWorkflowTemplatePanel
        defaultDealUuid={dealUuid}
        defaultProjectUuid={projectUuid}
        workflowTemplateUuid={selectedTemplateUuid}
        workflowTemplate={selectedTemplate}
        show={showApplyWorkflowTemplatePanel}
        onClose={onCancel}
      />
    </>
  );
};
